module.exports = __webpack_public_path__ + "img/copy-note.cf8ee845.svg";